import type { HubQuote } from '@adiox/api';

export type Direction = 'up' | 'down' | 'flat';

export interface QuoteView extends HubQuote {
  /** Movement of the bid since the previous update (drives the flash and the arrow, so colour is not the only cue). */
  direction: Direction;
  spread: number;
}

/**
 * Merges a quote batch into the map. Only the symbols in the batch get a new object, so components that select their own
 * symbol re-render only when that symbol changed. An older tick (by server time) never overwrites a newer one.
 */
export function applyQuotes(
  current: Record<string, QuoteView>,
  batch: HubQuote[],
): Record<string, QuoteView> {
  let next: Record<string, QuoteView> | null = null;
  for (const q of batch) {
    const previous = (next ?? current)[q.symbol];
    if (previous && q.t < previous.t) continue;
    const direction: Direction =
      !previous || q.bid === previous.bid
        ? (previous?.direction ?? 'flat')
        : q.bid > previous.bid
          ? 'up'
          : 'down';
    next ??= { ...current };
    next[q.symbol] = { ...q, direction, spread: q.ask - q.bid };
  }
  return next ?? current;
}
